// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_FsD","cls2":"ReferenceCard-cls2_WA- ReferenceCard-cls1_FsD","clickable":"ReferenceCard-clickable_X3r"};